import React from 'react';
import './Loading.css';

const Loading = ({ currentStep = 0, progress = 0, elapsedTime = null }) => {
  // Step configurations (simplified to 3 steps)
  const steps = [
    { icon: '📤', text: 'Getting file ready...', id: 0 },
    { icon: '🤖', text: 'Analyzing video...', id: 1 },
    { icon: '📊', text: 'Preparing file...', id: 2 }
  ];

  // Determine step status
  const getStepStatus = (stepId) => {
    if (stepId < currentStep) return 'completed';
    if (stepId === currentStep) return 'in-progress';
    return 'pending';
  };

  return (
    <div className="loading-container">
      <div className="loading-card">
        <div className="spinner"></div>
        <h2>Analyzing Your Demo</h2>
        <p>This may take nearly 3-5 minutes. Please don't close this window.</p>
        <div className="loading-steps">
          {steps.map((step) => {
            const status = getStepStatus(step.id);
            return (
              <div key={step.id} className={`step step-${status}`}>
                <div className="step-icon">{step.icon}</div>
                <div className="step-content">
                  <div className="step-text">
                    {step.text}
                    {/* Show elapsed time for analyzing step */}
                    {step.id === 1 && status === 'in-progress' && elapsedTime && (
                      <span className="elapsed-time"> ({elapsedTime} elapsed)</span>
                    )}
                  </div>
                </div>
                {status === 'completed' && (
                  <div className="step-checkmark">✓</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Loading;

